import { Component, OnInit, Input, ElementRef } from '@angular/core';

@Component({
  selector: 'carrossel',
  templateUrl: './carrossel.component.html',
  styleUrls: ['./carrossel.component.scss'],
})
export class CarrosselComponent implements OnInit {

  legenda: string;
  largura = 'auto';
  carregando = true;
  itensCarregados = 0;

  @Input() itens;

  constructor(private element: ElementRef) {
    this.element.nativeElement.style.display = 'block';
  }

  ngOnInit() {
    this.itens = this.desativarTodos();
    this.definirAtivo(0);
  }

  clickAnterior($event) {
    this.anterior();
  }

  clickProximo($event) {
    this.proximo();
  }

  imagemCarregada() {
    this.itensCarregados++;
    this.carregando = !(this.itensCarregados >= this.itens.length);
    if (!this.carregando) {
      this.redefinirLaguraPelaImagemAtiva();
    }
  }

  redefinirLaguraPelaImagemAtiva() {
    const img = this.element.nativeElement.querySelector('li.active img');
    if (img) {
      this.largura = `${img.width}px`;
    }
  }

  ativo() {
    return this.itens.filter(item => item.active)[0];
  }

  definirAtivo(indice) {
    this.itens[indice].active = true;
    this.legenda = this.itens[indice].title;
  }

  desativarTodos() {
    return this.itens.map(item => {
      item.active = false;
      return item;
    });
  }

  indiceAtivo() {
    return this.itens.indexOf(this.ativo());
  }

  isUltimoAtivo(indice) {
    return indice === this.itens.length - 1;
  }

  isPrimeiroAtivo(indice) {
    return indice === 0;
  }

  proximo() {
    const indiceAtivo = this.indiceAtivo();
    this.itens = this.desativarTodos();
    this.isUltimoAtivo(indiceAtivo) ?
      this.definirAtivo(0) :
      this.definirAtivo(indiceAtivo + 1);
    this.redefinirLaguraPelaImagemAtiva();
  }

  anterior() {
    const indiceAtivo = this.indiceAtivo();
    this.itens = this.desativarTodos();
    this.isPrimeiroAtivo(indiceAtivo) ?
      this.definirAtivo(this.itens.length - 1) :
      this.definirAtivo(indiceAtivo - 1);
    this.redefinirLaguraPelaImagemAtiva();
  }
}
